<template>
    <v-item-group :value="innerValue"
                  @change="emitInner($event)"
    >
        <v-container fluid pa-0>
            <v-row justify="center">
                <v-col :cols="cols"
                       :key="option.value"
                       class="d-flex justify-center"
                       v-for="(option) in options"
                >
                    <v-item :value="option.value"
                            v-slot:default="{ active, toggle }"
                    >
                        <v-hover>
                            <template v-slot:default="{ hover }">
                                <v-card :color="active ? 'rgba(255,255,255,0.2)' : 'transparent'"
                                        :max-height="option.image_height"
                                        :max-width="option.image_width"
                                        :style="{'box-shadow': (active || hover) ? '0 0 0 1px white !important' : 'none'}"
                                        @click="toggle"
                                        class="fill-height"
                                        v-if="option.url"
                                >
                                    <v-img :alt="option.text"
                                           :max-height="option.image_height"
                                           :max-width="option.image_width"
                                           :src="option.url"
                                           contain
                                           position="center center"
                                    ></v-img>
                                </v-card>
                                <v-card :color="active ? 'primary' : 'white'"
                                        :style="{'box-shadow': active ? '0 0 0 1px white !important' : 'none'}"
                                        @click="toggle"
                                        class="fill-height d-flex flex-grow-1"
                                        v-else
                                >
                                    <v-card-text class="fill-height pa-4"
                                                 style="display: flex; align-items: center; justify-content: center;"
                                    >
                                        <div class="text-center" :class="active ? 'white--text' : 'black--text'" v-html="option.text">

                                        </div>
                                    </v-card-text>
                                </v-card>
                            </template>
                        </v-hover>
                    </v-item>
                </v-col>
            </v-row>
        </v-container>
    </v-item-group>
</template>

<script>
    export default {
        name: "MultipleChoice",
        props: {
            value: {
                required: true,
            },
            options: {
                required: true,
                type: Array
            }
        },
        computed: {
          cols(){
            return 3;
          }
        },
        data: () => ({
            innerValue: null,
            // threshold: 40
        }),
        methods: {
            cloneInner() {
                this.innerValue = this.value;
            },
            emitInner(event) {
                this.innerValue = event;
                if (this.innerValue !== this.value) {
                    this.$emit('input', this.innerValue);
                }
            },
            // setCols() {
            //     if (this.images) {
            //         this.cols = 'auto';
            //     } else if (this.options.length > 0 && this.options[0].text.length >= this.threshold) {
            //         this.cols = 8;
            //     }
            //     //Else set cols equal to value based on current breakpoint?
            // }
        },
        mounted() {

            this.cloneInner();
            // this.setCols();
        },
        watch: {
            value() {
                this.cloneInner();
            }
        }
    }
</script>

<style scoped>

</style>